import { render } from "./Createorder.vue?vue&type=template&id=aaa37c56"
import script from "./Createorder.vue?vue&type=script&lang=js"
export * from "./Createorder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__